<div class="waiting-area-item" *ngIf="station"[ngClass]="{'selected': selected}">
    <sc-flex vertical fitHeight [centered]="true">
        <div>
            <sc-flex [centered]="true">
                <div class="title">{{station.name}}</div>
            </sc-flex>
        </div>
        <div>
            <sc-flex [centered]="true">
                <div class="amount">{{station.stationUsage.transports.length}}</div>
                <sc-content-spacer></sc-content-spacer>
                <div> / </div>
                <sc-content-spacer></sc-content-spacer>
                <div class="amount">{{station?.capacity}}</div>
            </sc-flex>
        </div>
    </sc-flex>
</div>
